import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { AllOrgsBillingData, BillingLogs } from "../../types"
import bbApi from "../../api"

// Define API
export const billingApi = createApi({
  reducerPath: "billingApi",
  baseQuery: fetchBaseQuery({ baseUrl: "/api/v1" }),
  endpoints: builder => ({
    fetchOrgsSystemUsage: builder.query<
      AllOrgsBillingData, // The returned data type
      { orgs: { id: string }[]; month?: string } // The arguments passed to the query
    >({
      queryFn: async ({ orgs, month }) => {
        const usageMap = await bbApi.billing.fetchAllSystemUsage(orgs, month)
        return { data: usageMap }
      }
    }),
    fetchOrgSystemUsage: builder.query<
      BillingLogs,
      { orgId: string | number; month?: string }
    >({
      queryFn: async ({ orgId }) => {
        const logs = await bbApi.billing.fetchOrgSystemUsage(orgId)
        return { data: logs }
      }
    })
  })
})

export const { useFetchOrgsSystemUsageQuery, useFetchOrgSystemUsageQuery } =
  billingApi
